export default __webpack_public_path__ + "static/media/Sansita-Italic.41b590ea.ttf";